import { render, staticRenderFns } from "./HumanCapitalFinancialInput.vue?vue&type=template&id=808b2e32&scoped=true&"
import script from "./HumanCapitalFinancialInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalFinancialInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalFinancialInput.vue?vue&type=style&index=0&id=808b2e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808b2e32",
  null
  
)

export default component.exports